import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoading = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"aria-labelledby": "ShuttlerockLoadingTitle",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 240 240",
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("title", {
		id: "ShuttlerockLoadingTitle",
		children: "Shuttlerock"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M216 154L204.146 165.854C182.611 144.32 152.861 131 120 131C87.1391 131 57.3893 144.32 35.8545 165.854L24 154L120 58L216 154Z"
	})]
});
export default SvgLoading;
